import find from "lodash-es/find";
import sum from "lodash-es/sum";

const rangeMap = {
  Bassa: "lowPrice",
  Media: "averagePrice",
  Alta: "highPrice",
  Altissima: "veryHighPrice"
};

export const getPrice = (room, dateRanges, dateFrom, dateTo) => {
  // get a list of price ranges ("Bassa", "Media") for each date to consider
  const priceRanges = getDateRange(dateFrom, dateTo).map(date => {
    const result = find(
      dateRanges,
      ({ dateFrom, dateTo }) =>
        date.isSameOrAfter(dateFrom, "day") &&
        date.isSameOrBefore(dateTo, "day")
    );
    if (!result) {
      console.log("Info: dateRanges =", dateRanges);
      throw new Error(`Could not find a price range for ${date.toString()}`);
    }
    return result.priceRange;
  });
  // maps the price ranges to actual day prices, and sum them
  const result = sum(priceRanges.map(priceRange => room[rangeMap[priceRange]]));
  // returns the result
  return result;
};

/**
 * Creates a range of dates, starting from the given date and arriving to the destination date, inclusive of the start and exclusive of the end, and taking into consideration a step of day granularity.
 * @param {moment.Moment} dateFrom the starting date
 * @param {moment.Moment} dateTo the ending date
 */
const getDateRange = (dateFrom, dateTo) =>
  dateFrom.isSameOrAfter(dateTo, "days")
    ? []
    : [dateFrom].concat(getDateRange(dateFrom.clone().add(1, "days"), dateTo));
